import { useContext } from "react";
import styles from "./GalleryImage.module.css";

export default function GalleryImage({
  image,
  onClick = () => {},
  value = 0,
  key = 0,
}) {

  return (
    <div
      className={styles[`image-container`]}
      onClick={onClick}
      value={value}
      key={key}
    >
      <img src={image} className={styles.image} alt="Image." />
      <div className={styles.title}>KUHINJSKO POSUĐE</div>
    </div>
  );
}
